<ca-list-shell
    (onTriggerSearchAndSort)="onListSearch($event)"
    [isLoading]="isLoading"
    [categoryOptions]="categoryOptions"
    [complianceOptions]="complianceOptions"
    emptyListMessage="{{ 'MODULES.NO_MODULES_AVAILABLE' | translate }}"
    [totalItemsCount]="modulesTotalCount"
    [showCategoryButton]="!showCreateButton"
    [availableFilterOptions]="availableFilterOptions"
    [sortOptions]="sortOptions"
    [pageSize]="pageSize"
>
    <section *ngFor="let i of gridRowCount" class="row list-container" data-uit="public-modules-list">
        <div class="col-12 col-sm-6 col-xl-3 p-2" *ngFor="let module of modules | slice: i * itemsPerColumn : (i + 1) * itemsPerColumn">
            <div class="grid-item-wrapper">
                <ca-module-item
                    [module]="module"
                    [shownVersion]="module.latestPublicVersion"
                    [showBanner]="hasGitCredentials"
                    data-uit="module-item"
                ></ca-module-item>
            </div>
        </div>
    </section>
</ca-list-shell>
